import moment from 'moment'
import React from 'react'
import { Typography } from '@material-ui/core'
import { Checkbox } from '@paro.io/base-ui'

interface TermsOfUseProps {
  companyName: string
  firstName: string
  isCompany: boolean
  lastName: string
  setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void
  acceptedTerms: boolean
  showError: boolean
  isByob?: boolean
}

const TermsOfUse = ({ companyName, firstName, isCompany, lastName, setFieldValue, acceptedTerms, showError, isByob=false }: TermsOfUseProps) => {
  const today = moment().format('MM/DD/YYYY')

  const label = !isCompany ? `${firstName} ${lastName} ${today}` : `${companyName} ${today}`

  return (
    <div className="text-grey text-sm my-8 flex flex-row">
      <div className="mr-2 mt-1">
        <Checkbox
          id='acceptedTerms'
          isChecked={acceptedTerms}
          onChange={() => { setFieldValue('acceptedTerms', !acceptedTerms) }}
        />      
      </div>
      <div>
        <p>
          I agree to accept the terms of{' '}
          <a href={isByob ? "https://paro.ai/AI-platform-terms-of-use/" : "https://paro.io/talent-terms-of-use/"} target="_blank" rel="noopener noreferrer">
            <span className="text-link">this agreement</span>
          </a>
          , and understand that it contains an Arbitration Agreement, including a class and collective action waiver. By
          clicking my acceptance, I will be able to accept a SOW through Paro.
        </p>
        <span className="text-lg">{label}</span>
        {showError && !acceptedTerms &&
        <div className="mt-2">
          <Typography variant="body2" color="error">
            <strong>Please review and accept the Terms & Conditions to continue</strong>
          </Typography>
          <Typography variant="body2" color="error">
            Before proceeding, you must acknowledge our Terms & Conditions to ensure a smooth experience and compliance with platform guidelines.
          </Typography>
        </div>
      }
      </div>
    </div>
  )
}

export default TermsOfUse
